<template>
    <div id="app" @click="popup" style="background-color:#fafafa">
        <NavBar/>
        <router-view/>
        <Footer/>
    </div>
</template>
<script>
import NavBar from './components/NavBar'
import Footer from './components/Footer'
import {mapState, mapActions} from 'vuex';

export default {
    name: 'App',
    components: {
        NavBar,
        Footer
    },
    beforeMount() {
        this.CheckPath(this.$router.currentRoute.path)
        this.$store.dispatch('FetchEntities')
        this.$store.dispatch('FetchOrder')
        this.$store.dispatch('GetHomeProducts')
        this.$store.dispatch('GetCurrentCustomer')
        this.$store.dispatch('GetFavorites')
    },
    methods: {
        CheckPath(path){
            this.$store.commit("StateAssign",{
                showInfoFooter: path !== ("/cambios-y-devoluciones" || "/comentarios-y-sugerencias" || "/aviso-de-privacidad" || "/preguntas-frecuentes" || "/producto")
            })
        },
        popup(e){
           if(!e.target.classList.contains('popup')){
            let popup = document.getElementById("myPopup") 
            if(popup){popup.classList.remove('show')}
            
           }
            
        },
        ...mapActions(['GetCurrentCustomer','GetFavorites'])
    },
    computed: {
        ...mapState(['showCart', 'currentCustomer'])
    },
    watch: {
    // whenever question changes, this function will run
      $route (to){
        this.CheckPath(to.path)  
      }
    }
}
</script>

<style>
    @import 'variables.css';

    * {
        color: var(--dark-gofarma);
        font-family: 'Gilroy-Light',serif;
    }

    .bold{
        font-family: 'Gilroy-Bold', sans-serif;
    }

    .underline{
        text-decoration: underline;
    }

    .no-scroll{
        overflow: hidden;
    }

    .nav-container {
        display: flex;
        align-items: center;
    }

    .grid-content {
        grid-area: content;
    }

    .router {
        padding-left: 1rem;
    }

    .fa-whatsapp, .fa-phone{
         color: var(--dark-gofarma);
    }
     .fa-whatsapp.footer-icon, .fa-phone.footer-icon, .fa-user, .fa-map-marker {
         color: #fafafa;
    }
    .left{
        text-align: left !important;
    }
    .fa-user{
        margin-left: 1rem;
    }
    .fa-whatsapp {
        margin-left: 0.9375rem;
        padding-right: 0.5rem;
    }

    .fa-phone {
        padding-right: 0.5rem;
    }
    .fa-times{
        color:white;
    }
    .arrow-dropdown{
        padding-left: 0.625rem;
        cursor: pointer;
    }

    .input-delta:disabled{
        background: white;
    }


    .info-numbers {
        display: block;
        margin-block-start: 1em;
        margin-block-end: 1em;
        font-size: 1.3em;
        font-weight: lighter;
        font-family: 'Gilroy-Bold', sans-serif;
        cursor: pointer;
        margin-inline-end: 0em;
    }

    body.swal2-shown.swal2-height-auto{
        padding-right:0px!important
    }

    .swal2-shown {
         padding-right:0px!important
    }
    .fa-facebook {
        margin-left: 0.9375rem;
        padding-right: 0.5rem;
    }

    .fa-instagram {
        margin-left: 0.9375rem;
        padding-right: 0.5rem;
    }

     .instructions{
        width: 70%;
        height: auto;
        padding: 2rem 0rem 2rem 0rem;
    }

    .categories-container{
        text-align:left;
        color:white;
        font-size:1.4rem;
        padding: 1rem 0rem 0rem 1rem; 
    }
    .sub-categories{
        padding: .5rem 0rem .5rem 2rem;
        font-size: 1rem;
        color:#fafafa;
    }

    .large-container{
        margin:auto;
        width:70%;
    }

    .transparent{
        color:transparent;
    }
    .big-paddings {
        padding: 0 7rem 0 7rem;
        box-sizing: border-box;
    }
    @media (max-width: 64rem){
        .big-paddings {
            padding: 0 2rem 0 2rem;
        }   
    }
    .card {
        position: relative;
        box-shadow: 0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.2);
        transition: 0.3s;
        margin: 0.3125rem;
        box-sizing: border-box;
        text-align: justify;
    }
    .product-info{
        font-weight: bold;
        width: 90%;
        font-size: 1.0625rem;
        text-align: left;
        padding-left:.2rem;
    }
    .cost{
        font-family: "Segoe UI";
        font-size:1.5rem;
    }   
    .discount-cost{
        font-size: 1rem;
        text-decoration: line-through;
    }
    .today-only {
        margin: 0 0.25rem 0 0.25rem;
        padding: 0.3125rem;
        color: var(--light-blue);
        font-weight: bold;
        border-radius: 0.3125rem;
        font-family: "Segoe UI";
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    #nav {
        padding: 0rem;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    .container {
        display: flex;
    }

    .contact {
        display: flex;
        justify-content: flex-end;
        margin-right: 1em;
    }

    .container-item {
        align-items: center;
        flex-grow: 3;
    }

    .centered {
        margin: auto;
        width: 80%;
        padding: 0.625rem;
    }

    .mid-container{
        margin:auto;
        width: 50%;
    }

    .small-container{
        margin:auto;
        width: 30%;
    }
    
    .modality{
        width: 70%;
        padding-top:3rem;
    }

    .checkbox-container{
        width:50%;
        padding-bottom:1rem;
        padding-left:.5rem;
    }

    .fa-circle, .fa-check-square{
        color:gray;
        padding-right: .5rem;
    }

    .hidden{
        display: none;
    }
    .input-table{
        width: 100%;
        min-height: 1.5625rem;
        padding: 0.3125rem 0.625rem;
        line-height: 1.6;
        background-color: #fff;
        border: 0.0625rem solid #ddd;
        border-radius: 0.25rem;
        outline: 0;
        text-align: left;
        border: none;
        /* margin-bottom: 1em; */
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }   

    .td-right{
        text-align: right;
    }
    .ui.blue.button{
        background-color: var(--light-blue);
        color: #fff;
        text-shadow: none;
        background-image: none;
        font-family: Gilroy-Bold, sans-serif;
    }

    .ui.gofarma.button{
        background-color: var(--light-gofarma);
        color: #fff;
        text-shadow: none;
        background-image: none;
    }
    .ui.default.button{
        background-color:var(--gray-gofarma);
        color: #fff;
        text-shadow: none;
        background-image: none;
        margin-top:.5rem
    }

    .ui.green.button{
        background-color:var(--light-green);
        color: #fff;
        text-shadow: none;
        background-image: none;
        margin-top:.5rem
    }

    .ui.danger.button{
        background-color: var(--danger);
        color: #fff;
        text-shadow: none;
        background-image: none;
        font-family: Gilroy-Bold, sans-serif;
    }

    
    .row-danger{
        color:red;
    }
    .form-title{
        text-align: left;
        padding-bottom:1rem;
    }

    button, .pointer{
        cursor: pointer;
    }

    .pointer{
        cursor: pointer;
    }
    .ui.primary.button, .ui.primary.buttons .button {
        background-color: rgb(48, 217, 196);
        color: #fff;
        text-shadow: none;
        background-image: none;
    }

    .ui.primary.button {
        box-shadow: 0 0 0 0 rgba(34, 36, 38, .15) inset;
    }

    .ui.strong.button, .ui.strong.buttons .button {
        background-color: var(--dark-gofarma);
        color: #fff;
        text-shadow: none;
        background-image: none;
    }

    .ui.strong.button {
        box-shadow: 0 0 0 0 rgba(34, 36, 38, .15) inset;
    }

    .ui.button, .ui.buttons .button, .ui.buttons .or {
        font-size: 1rem;
    }

    .ui.button {
        cursor: pointer;
        display: inline-block;
        min-height: 1em;
        outline: 0;
        border: none;
        vertical-align: baseline;
        background: #e0e1e2 none;
        color: rgba(0, 0, 0, .6);
        font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
        margin: 0 .25em .5em 0;
        padding: .78571429em 1.5em .78571429em;
        text-transform: uppercase;
        text-shadow: none;
        font-weight: 700;
        line-height: 1em;
        font-style: normal;
        text-align: center;
        text-decoration: none;
        border-radius: 0;
        box-shadow: 0 0 0 0.0625rem transparent inset, 0 0 0 0 rgba(34, 36, 38, .15) inset;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-transition: opacity .1s ease, background-color .1s ease, color .1s ease, box-shadow .1s ease, background .1s ease;
        transition: opacity .1s ease, background-color .1s ease, color .1s ease, box-shadow .1s ease, background .1s ease;
        -webkit-tap-highlight-color: transparent;
    }

    
    .profile-control {
        width: 100%;
        min-height: 1.5625rem;
        padding: 0.3125rem 0.625rem;
        line-height: 1.6;
        background-color: #fff;
        border: 0.0625rem solid #ddd;
        border-radius: 0.25rem;
        outline: 0;
        margin-bottom: 1em;
        text-align: center;
        box-sizing: border-box;
    }

    .title{
        font-family: Gilroy-Bold, sans-serif;
    }

    .ui.table:first-child {
        margin-top: 0;
    }
    .ui.table {
        font-size: 1rem;
    }

    .ui.table {
        width: 100%;
        background: #fff;
        margin: 1rem 0;
        border: 1px solid rgba(34,36,38,.15);
        box-shadow: none;
        border-radius: .28571429rem;
        text-align: left;
        color: rgba(0,0,0,.87);
        border-collapse: collapse;
        border-spacing: 0;
        
    }
    .ui.table thead th {
        cursor: auto;
        background: #f9fafb;
        text-align: inherit;
        padding: .92857143em .78571429em;
        vertical-align: inherit;
        font-style: none;
        font-weight: 700;
        text-transform: none;
        border-bottom: 1px solid rgba(34,36,38,.1);
        border-left: none;
    }

    .ui.table td {
        padding: .78571429em .78571429em;
        text-align: inherit;
    }

    .small-margins{
        margin: .5rem;
    }

    .aside-responsive{
        display:none;
    }

    .aside-responsive-content{
        width:auto;
        padding-left:1rem;
    }

    .x-scroll{
        overflow-x:auto;
    }
    .btn-positive {
        border-color: var(--strong-green) var(--strong-green) var(--strong-green);
        background-color: var(--light-green);
        width: 90%;
    }

    .btn-light {
        border-color: var(--light-gofarma) var(--light-gofarma) var(--light-gofarma);
        background-color: var(--light-gofarma);
        width: 90%;

    }

    .btn-primary {
        border-color: var(--blue-gofarma) var(--blue-gofarma) var(--blue-gofarma);
        background-color: var(--blue-gofarma);
        width: 90%;
    }
    .btn-light-blue{
        border-color: var(--light-blue) var(--light-blue) var(--light-blue);
        background-color: var(--light-blue);
        width: 90%;
        color:white;
    }

    .btn {
        display: inline-block;
        padding: 0.1875rem 0.5rem;
        margin-bottom: 0;
        line-height: 1.4;
        white-space: nowrap;
        background-image: none;
        border: 0.0625rem solid transparent;
        border-radius: 0.25rem;
        box-shadow: 0 0.0625rem 0.0625rem rgba(0, 0, 0, .06);
    }

    .btn {
        vertical-align: middle;
        -webkit-app-region: no-drag;
    }

    .btn-negative, .btn-positive, .btn-primary, .btn-warning, .btn-light {
        color: #fff;
        text-shadow: 0 0.0625rem 0.0625rem rgba(0, 0, 0, .1);
    }

    .img-slider{
        width: 70%;
        height: 25rem!important;
    }

    .product-slider{
        width: 100%;
        height: auto!important;
        border-top: none;
        border-left:0.01rem solid rgb(243, 243, 243);
        border-bottom:0.01rem solid rgb(243, 243, 243);
        border-right:0.01rem solid rgb(243, 243, 243);
    }

    .my-medicine{
        width: 100%;
        text-align: center;
        height: auto;
    
    }
    .product-slider-header{
        width:100%;
        text-align:left;
        background-color: rgb(243, 243, 243)
    }


    .product-slider-header h3{
        margin: .5rem 0rem .5rem 2rem;
    }

    .product-name{
        font-size: .9rem; 
    }

    @media screen and (min-width: 1025.0000000001px) {
        .img-slider {
            width: 70%!important;
            height: 25rem;
        }
    }

    @media screen and (min-width: 26.25000000000625rem) and (max-width: 64rem) {
        .img-slider {
            width: 70%;
            height: 18rem;
        }
    }

    @media screen and (max-width: 26.25rem) {
        .img-slider {
            width: 100%;
            height: 10rem!important;
        }
        .modality{
            width: 95%;
        }
        .instructions{
            width: 100%;
        }
        .mid-container{
            width: 100%;
    }

    }

    .left-upper-corner-product {
        position: absolute;
        top: 10rem;
        right: 0.625rem;
        
    }


    button.hooper-next.is-disabled{
        display: none !important;
    }

    .light-blue{
        color:var(--light-blue)
    }

    /**********************
	**** STEPPER CSS *****
   **********************/
	.md-stepper-horizontal {
		display:table;
		width:100%;
		margin: 0 auto 20px;
	}
	.md-stepper-horizontal .md-step {
		display:table-cell;
		position:relative;
        padding: 20px 8px 20px 8px;
        overflow-x: auto;
	}
	.md-stepper-horizontal .md-step:hover,
	.md-stepper-horizontal .md-step:active {
		background-color:rgba(0,0,0,0.04);
	}
	.md-stepper-horizontal .md-step:active {
		border-radius: 15% / 75%;
	}
	.md-stepper-horizontal .md-step:first-child:active {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}
	.md-stepper-horizontal .md-step:last-child:active {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	.md-stepper-horizontal .md-step:hover .md-step-circle {
		background-color:#757575;
    }
    .md-stepper-horizontal .md-step:hover .md-step-circle-canceled {
		background-color:#757575;
    }
    .md-stepper-horizontal .md-step:hover .md-step-circle-canceled {
		background-color:#757575;
	}
	.md-stepper-horizontal .md-step:first-child .md-step-bar-left,
	.md-stepper-horizontal .md-step:last-child .md-step-bar-right {
		display:none;
	}
	.md-stepper-horizontal .md-step.active .md-step-circle {
		background-color: var(--light-blue)!important;
	}
    .md-stepper-horizontal .md-step.active .md-step-circle-canceled{
        background-color: var(--danger)!important;
    }
   
	.md-stepper-horizontal .md-step.current .md-step-circle  {
		background-color: #ff6700;
    }
    
	.md-stepper-horizontal .md-step.done .md-step-circle {
		background-color:var(--gray-gofarma);
	}
	.md-stepper-horizontal .md-step .md-step-optional {
		font-size:12px;
	}
	.md-stepper-horizontal .md-step.active .md-step-optional {
		color:rgba(0,0,0,.54);
	}
	.md-stepper-horizontal .md-step .md-step-title {
		margin-top:16px;
		font-size:16px;
		font-weight:600;
	}
	.md-stepper-horizontal .md-step .md-step-title,
	.md-stepper-horizontal .md-step .md-step-optional {
		text-align: center;
	}
	.md-stepper-horizontal .md-step.active .md-step-title {
		font-weight: 600;
		color:rgba(0,0,0,.87);
	}
	.md-stepper-horizontal .md-step.editable .md-step-circle {
		-moz-transform: scaleX(-1);
		-o-transform: scaleX(-1);
		-webkit-transform: scaleX(-1);
		transform: scaleX(-1);
    }
    
    .md-stepper-horizontal .md-step.editable .md-step-circle-canceled {
		-moz-transform: scaleX(-1);
		-o-transform: scaleX(-1);
		-webkit-transform: scaleX(-1);
		transform: scaleX(-1);
	}
	.md-stepper-horizontal .md-step .md-step-bar-left,
	.md-stepper-horizontal .md-step .md-step-bar-right {
		position:absolute;
		top:36px;
		height:1px;
		border-top:1px solid #DDDDDD;
	}
	.md-stepper-horizontal .md-step .md-step-bar-right {
		right:0;
		left:50%;
		margin-left:20px;
	}
	.md-stepper-horizontal .md-step .md-step-bar-left {
		left:0;
		right:50%;
		margin-right:20px;
	}
	.md-stepper-horizontal .md-step .md-step-circle {
		width:35px;
		height:35px;
		margin:0 auto;
		background-color:#999999;
		border-radius: 50%;
		text-align: center;
		line-height:35px;
		font-size: 16px;
		font-weight: 600;
		color:#FFFFFF;
    }
    
    .md-stepper-horizontal .md-step .md-step-circle-canceled {
		width:35px;
		height:35px;
		margin:0 auto;
		background-color:#999999;
		border-radius: 50%;
		text-align: center;
		line-height:35px;
		font-size: 16px;
		font-weight: 600;
		color:#FFFFFF;
	}
	.md-step *{
		pointer-events: none;
	}

    /*********************************************************************
        This is all the boilerplate CSS rules
        Everything will be displayed with a combination of flex and grid.
     *********************************************************************/

    body {
        margin: 0;
        font-family: 'Avenir';
        line-height: 1.5;
        min-height: 100vh;
        background-color: #FFF;
    }

    body.active {
        overflow-y: hidden;
    }


    /************************************************************************************
    *********** From here on out its CSS rules that apply to the page *******************
    *************************************************************************************/
    .grid-toolbar {
        grid-area: toolbar;
    }

    /************************************************************************************
    *************************** GOFARMA ELEMENTS RULES ***********************************
    *************************************************************************************/

    .row {
        display: flex;
        flex-flow: row;
    }

    .row .grow {
        flex-grow: 1;
    }

    .row.wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .column .grow {
        flex-grow: 1;
    }
    .column.wrap{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .column{
        display: flex;
        flex-flow: column;
    }

    .center {
        justify-content: center;
        align-items: center;
    }

    .columns {
        display: flex;
        flex-flow: column;
    }

    .columns.space-between {
        justify-content: space-between;
    }


    .number-input{
        display: flex;
        flex-flow: row;
        width: 30%;
    }

    .number-input input::-webkit-outer-spin-button,
    .number-input input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    .number-input input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }

    .number-input input{
        -webkit-appearance: none;
        box-sizing: border-box;
        border-left: none;
        border-right: none;
        border-top: 1px solid var(--dark-gofarma);
        border-bottom: 1px solid var(--dark-gofarma);
        float: left;
        font-size: 16px;
        height: 40px;
        margin: 0;
        outline: none;
        text-align: center;
        width: calc(100% - 80px);
    }

    .number-input button {
        height: 40px;
        width: 30px;
        background: white;
        border: none;
        font-size: 1.2em;
    }

    .number-input button:first-child{
        border-left: 1px solid var(--dark-gofarma);
        border-top: 1px solid var(--dark-gofarma);
        border-bottom: 1px solid var(--dark-gofarma);
    }

    .number-input button:last-child{
        border-right: 1px solid var(--dark-gofarma);
        border-top: 1px solid var(--dark-gofarma);
        border-bottom: 1px solid var(--dark-gofarma);
    }

    .row.start, .columns.start {
        justify-content: flex-start;
    }

    .row.end, .columns.end {
        justify-content: flex-end;
    }

    .toolbar {
        box-sizing: border-box;
        padding: 0 1.875rem;
        width: 100%;
        height: 5.125rem;
    }

    .toolbar .fa {
        color: white;
    }

    .gofarma-bg-blue {
        background: var(--dark-gofarma);
    }

    .active[data-cart-loader] {
        display: flex;
    }

    .narrow-menu {
        background: var(--dark-gofarma);
        position: fixed;
        width: 30%;
        top: 0;
        left: -100%;
        height: 100%;
        overflow-y: auto;
        box-shadow: 0 0 0.3125rem rgba(0, 0, 0, 1);
        -webkit-transition: left 0.5s; /* Safari */
        transition: left 0.5s;
        z-index: 99999999999;
    }

    .narrow-menu.active {
        left: 0;
    }

    .narrow-menu ul {
        color: white;
        font-weight: bold;
        display: block;
        font-size: 1.25rem;
        height: auto;
        margin: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 1.5625rem;
        list-style-type: none;
    }

    .narrow-menu ul li {
        margin-bottom: 0.625rem;
    }

    .narrow-menu ul li a {
        text-decoration: none;
        color: white;
    }

    .narrow-menu ul li[data-child] {
        display: none;
        margin-left: 1.5625rem;
    }

    .narrow-menu ul li.active[data-child] {
        display: list-item;
    }

    .space-between{
        justify-content: space-between !important;
    }

    .icon-space-right{
        margin-right:.5rem;
    }

    .icon-space-left{
        margin-left:.5rem !important;
    }

    .margin-bottom{
        margin-bottom: .5rem !important;
    }

    .margin-top{
        margin-top:1.5rem;
    }

    ::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar
    {
        width: 12px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb
    {
        background-color: #005e8a;
    }

    .left-upper-corner {
        position: absolute;
        top: 0.625rem;
        right: 0.625rem;
    }

    .search {
        height: 9.375rem;
        padding: 0 8% 0.3125rem 8%;
        box-sizing: border-box;
    }

    .home, .main-section {
        padding: 0.625rem 8% 0.625rem 8%;
    }

    @font-face {
        font-family: 'Gilroy-Light';
        src: url('assets/fonts/Gilroy-Light.otf');
    }
    
    @font-face {
        font-family: 'Gilroy-Bold';
        src: url('assets/fonts/Gilroy-ExtraBold.otf');
    }

    .overlay {
        top: 0;
        display: none;
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.75);
        z-index: 99999;
        flex-flow: row;
    }

    .card {
        position: relative;
        box-shadow: 0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.2);
        transition: 0.3s;
        margin: 0.3125rem;
        box-sizing: border-box;
    }

    .card.background {
        background-color: #FAFAFA;
    }

    .card .availability {
        position: absolute;
        top: 0.625rem;
        right: 0.625rem;
        padding: .25rem;
        background-color: var(--dark-gofarma);
        border-radius: 0.3125rem;
        z-index: 10;
        font-size: 0.75rem;
        color: white;
        font-weight: bold;
    }

    .card .availability.not {
        background-color: #bababa;
    }
    
    .card img {
        height: 8.75rem;
        width: auto;
        max-width: 80%;
    }

    .card:hover {
        box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.2);
    }

    .overlay.active {
        display: flex;
    }

    .overlay i.fa-close, .overlay i.fa-times {
        color: white;
        position: absolute;
        top: 0.3125rem;
        right: 0.3125rem;
        z-index: 99999999999;
    }

    .uppercase{
        text-transform: uppercase;
    }

    .inactive {
        display: none !important;
    }

    .hidden {
        display: none;
    }

    .wide {
        width: 100%;
    }
    
    .text-start{
        text-align: start;
    }

    .bold{
        font-weight: bolder;
    }

    .clickable{
        cursor: pointer;
    }

    .white{
        color: white;
    }

    .space-around{
        justify-content: space-around !important;
    }

    body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){
        overflow: auto !important;
    }

    @media screen and (min-width: 1025.0000000001px) {
        [data-not-wide-mode] {
            display: none !important;
        }
    }

    @media screen and (min-width: 26.25000000000625rem) and (max-width: 64rem) {
        [data-not-medium-mode] {
            display: none !important;
        }
    }

    @media screen and (max-width: 420px) {
        [data-not-narrow-mode] {
            display: none !important;
        }
    }
</style>

